import EmailLink from "./EmailLink";
export default EmailLink;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/EmailLink/index.tsx